import CustomCard from "components/CustomCard";
import { Divider, Stack, Typography } from "@mui/material";
import TextInput from "components/files/TextInput";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CustomButton from "components/CustomButton";
import { endpointName, SUBJECT_TYPES, SUPPORT_BUTTON } from "./const";
import { QueryBuilder } from "@mui/icons-material";
import SelectInput from "components/files/SelectInput";
import CustomDialog from "components/CustomDialog";
import { setOpenSupport, setShowLoading } from "store/sysSlice";
import http from "../../http"
import { apiUrl } from "config/settings";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const Support = () => {
  const dispatch = useDispatch()
  const { bt } = useBizTypeTranslation();
  const { reset, handleSubmit, control, formState: { errors } } = useForm();
  const user = useSelector((state) => state.userSettings?.user);
  const open = useSelector((state) => state.sys?.openSupport);
  const [supportGuidGuid, setSupportGuidGuid] = useState(null)

  useEffect(() => {
    reset({
      fn: user?.fn,
      ln: user?.ln,
      tel: user?.tel,
      email: user?.email,
    })
  }, [user]);

  const onClose = () => {
    setSupportGuidGuid(null)
    dispatch(setOpenSupport(false))
  }

  const onSubmit = (values) => {
    const data = {
      email: values?.email,
      fn: values?.fn,
      ln: values?.ln,
      message: values?.message,
      subject: bt(values?.subject),
      tel: values?.tel
    }
    dispatch(setShowLoading(true));
    http.post(`${apiUrl}/${endpointName}/sendMail`, data)
      .then((res) => {
        setSupportGuidGuid(res?.data?.guid)
        dispatch(setShowLoading(false))
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });

  }

  const onClickBtn = (btn) => {
    window.open(`${btn?.value}`, "_blank");
  }

  return (
    <>
      <CustomDialog
        onClose={onClose}
        title="SUPPORT"
        open={open}
      >
        <Stack
          width="100%"
          direction={{ xs: "column", md: "row" }}
          spacing={3}
        >

          <form onSubmit={handleSubmit(onSubmit)}>
            <CustomCard padding={2} spacing={2}>
              <Stack spacing={2}>
                <Typography fontWeight="bold">
                  שליחת פניה לנציג
                </Typography>

                <Stack direction="row" spacing={2}>
                  <TextInput
                    fullWidth
                    errors={errors}
                    name="fn"
                    addFlex
                    required
                    title="FN"
                    control={control}
                  />
                  <TextInput
                    fullWidth
                    errors={errors}
                    name="ln"
                    title="LN"
                    addFlex
                    required
                    control={control}
                  />
                </Stack>

                <Stack direction="row" spacing={2}>
                  <TextInput
                    fullWidth
                    errors={errors}
                    name="tel"
                    title="TEL"
                    addFlex
                    required
                    control={control}
                  />

                  <TextInput
                    fullWidth
                    errors={errors}
                    name="email"
                    title="EMAIL"
                    addFlex
                    control={control}
                  />
                </Stack>
              </Stack>


              <Stack borderTop={1} borderColor="bgDivider.main" pt={2} spacing={1.5}>
                <SelectInput
                  control={control}
                  errors={errors}
                  name="subject"
                  title="SUPPORT_SUBJECT"
                  required
                  options={SUBJECT_TYPES}
                />

                <TextInput
                  width="100%"
                  errors={errors}
                  name="message"
                  rows={8}
                  title="SUPPORT_MESSAGE"
                  control={control}
                />
              </Stack>

              <CustomButton onClick={() => handleSubmit(onSubmit)()} title="SEND" />
            </CustomCard>
          </form>

          <Stack width={{ xs: "100%", md: "auto" }} justifyContent="space-between" spacing={2} >
            {SUPPORT_BUTTON?.map(btn => {
              return (
                <CustomCard
                  pb={2}
                  pointer
                  padding={2}
                  onClick={() => onClickBtn(btn)}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    {btn?.icon}
                    <Typography>{btn?.title}</Typography>
                  </Stack>
                  <Typography>{btn?.titleValue}</Typography>

                  <Divider />

                  <Typography variant="body2">{btn?.info}</Typography>
                </CustomCard>
              )
            })}

            <CustomCard padding={2} pb={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <QueryBuilder sx={{ color: "info.main" }} />
                <Typography>שעות פעילות</Typography>
              </Stack>

              <Stack>
                <Typography>א׳–ה׳: 08:00–16:00</Typography>
                <Typography>ו׳–שבת וחגים: סגור</Typography>
              </Stack>
            </CustomCard>
          </Stack>

        </Stack>
      </CustomDialog>


      <CustomDialog
        width={300}
        title="MASSAGE"
        closeBtn="CLOSE"
        open={supportGuidGuid} onClose={onClose}
      >
        <Stack alignItems='center' spacing={2}>
          <Stack alignItems='center'>
            <Typography color="success.main" >{bt('SUPPORT_RECEIVED_1')}</Typography>
            <Typography textAlign="center">{bt('SUPPORT_RECEIVED_2')}</Typography>
          </Stack>
          <Typography variant="h6" fontWeight="bold" color="info.main">{`${bt('SUPPORT_NUMBER')}: ${supportGuidGuid}`}</Typography>
          <Typography textAlign="center" fontSize={12}>{bt('SAVE_SUPPORT_NUMBER')}</Typography>
        </Stack>
      </CustomDialog>

    </>
  );
};
export default Support;
